import keyMirror from '../../utils/keyMirror';

export default keyMirror({
    SET_DIVISION_LIST: null,
    SET_SUBDIVISION_LIST: null,
    SET_SELECTED_DIVISION: null,
    SET_SELECTED_SUBDIVISIONS: null
});